export default __webpack_public_path__ + "static/media/banner-sub-01.7a7e5db4.png";